import React, { useState } from 'react';
import { Card, Tabs, Tab } from 'react-bootstrap';
import DuyetVanBangChungChi from './DuyetVanBangChungChi';
import ThongKe from './ThongKe';

const DanhSachDuyetNgoaiNgu = () => {
    const [key, setKey] = useState('duyet');

    return (
        <div className="container-fluid py-4">
            <Card style={{ borderRadius: '16px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <Card.Header className="bg-white border-bottom-0 pt-4 px-4">
                    <h4 className="mb-0 text-primary fw-bold">Danh sách duyệt ngoại ngữ</h4>
                </Card.Header>
                <Card.Body className="px-4 pb-4">
                    <Tabs
                        id="thong-ke-duyet-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-0 custom-tabs-container"
                    >
                        <Tab 
                            eventKey="duyet" 
                            title={
                                <div className="d-flex align-items-center">
                                    <i className="fas fa-list-ul me-2"></i>
                                    <span>Duyệt văn bằng chứng chỉ</span>
                                </div>
                            }
                        >
                            <DuyetVanBangChungChi />
                        </Tab>
                        <Tab 
                            eventKey="tong-quan" 
                            title={
                                <div className="d-flex align-items-center">
                                    <i className="fas fa-chart-pie me-2"></i>
                                    <span>Thống kê</span>
                                </div>
                            }
                        >
                            <ThongKe />
                        </Tab>
                    </Tabs>
                </Card.Body>
            </Card>

            <style>
                {`
                    .custom-tabs-container.nav-tabs {
                        border-bottom: 1px solid #dee2e6;
                        gap: 0;
                        padding: 0;
                        margin: 0;
                    }
                    .custom-tabs-container .nav-item {
                        margin-bottom: -1px;
                    }
                    .custom-tabs-container .nav-link {
                        border: 1px solid transparent;
                        border-top-left-radius: 8px;
                        border-top-right-radius: 8px;
                        color: #6c757d;
                        font-weight: 500;
                        padding: 12px 24px;
                        transition: all 0.2s ease;
                        background-color: #f8f9fa;
                        display: flex;
                        align-items: center;
                        margin-right: 4px;
                    }
                    .custom-tabs-container .nav-link:hover {
                        background-color: #e9ecef;
                        border-color: #dee2e6 #dee2e6 #fff;
                    }
                    .custom-tabs-container .nav-link.active {
                        color: #0d6efd;
                        background-color: #fff;
                        border-color: #dee2e6 #dee2e6 #fff;
                        border-bottom: 3px solid #0d6efd;
                    }
                    .custom-tabs-container .nav-link i {
                        font-size: 1.1rem;
                    }
                    .custom-tabs-container .nav-link.active i {
                        color: #0d6efd;
                    }
                `}
            </style>
        </div>
    );
};

export default DanhSachDuyetNgoaiNgu;
